import React from "react";
import styled from "styled-components";
import caretDown from "resources/img/caret_down.svg";
import logger from "utils/logger";

const StyledSelect = styled.select`
  /* 隐藏图标 */
  appearance: none;
  background-image: url(${caretDown});
  background-position: right 65%;
  background-repeat: no-repeat;

  background-color: transparent;
  border: none;
  outline: none;
  padding-right: 16px;
  font-size: ${({ theme }) => theme.fontSize.slarge};

  /* IE隐藏图标 */
  ::-ms-expand {
    display: none;
  }
`;

const Select = ({
  options = [],
  name,
  value,
  onChange = (v) => {
    logger.log("修改select的选项", v);
  },
  ...rest
}) => {
  //
  return (
    <StyledSelect
      name={name}
      value={value}
      onChange={(e) => onChange(name, e.currentTarget.value)}
      {...rest}
    >
      <option style={{ display: "none" }}></option>
      {options.map((o, index) => (
        <option key={index} value={o.value}>
          {`${o.desc}`}
        </option>
      ))}
    </StyledSelect>
  );
};

export default Select;
